/* Arbove — FAQ : filtrage par catégorie (onglets). L'accordéon est natif (<details>). */
(function () {
  if (window.__arFaq) return;
  window.__arFaq = true;

  function setup(sec) {
    var tabs = sec.querySelectorAll('.faq__tab');
    var items = sec.querySelectorAll('.faq-item');
    if (!tabs.length) return;

    function activate(cat) {
      for (var i = 0; i < tabs.length; i++) {
        var on = tabs[i].getAttribute('data-cat') === cat;
        tabs[i].classList.toggle('is-active', on);
        tabs[i].setAttribute('aria-selected', on ? 'true' : 'false');
      }
      for (var j = 0; j < items.length; j++) {
        var show = items[j].getAttribute('data-cat') === cat;
        items[j].hidden = !show;
        if (!show) items[j].removeAttribute('open');
      }
    }

    for (var k = 0; k < tabs.length; k++) {
      (function (t) {
        t.addEventListener('click', function () { activate(t.getAttribute('data-cat')); });
      })(tabs[k]);
    }
    activate(tabs[0].getAttribute('data-cat'));
  }

  function init() {
    var secs = document.querySelectorAll('[data-faq]');
    for (var i = 0; i < secs.length; i++) setup(secs[i]);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
